import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
    Switch,
    Route,
} from 'react-router-dom';
import { Spin, Icon } from 'antd';
import Layout from '../Layout';
import Sidebar from './Sidebar';
import Profile from './Profile';
import Branches from './Branches';
import Admins from './Admins';
import BranchContainer from './BranchContainer';
import AdminContainer from './AdminContainer';
import Settings from './DLO/Settings';
import Engineers from './DLO/EngineersContainer';
import NonEngineers from './DLO/NonEngineersContainer';
import {
    ContractorContainer,
    Contractors,
    Settings as ContractorSettings
} from './contractor';
import Properties from './property/Properties';
import RetiredProperties from './property/RetiredProperties';
import ContractorProperties from './contractor/Properties';
import Property from './property/PropertyContainer';

class Root extends Component {
    renderRoutes() {
        const {match, me: {roles}} = this.props;
        const role = roles.map(r => r.name).pop();
        if (!role) return null;

        return (
            <div>
                <Switch>
                    <Route path={`${match.url}/profile`} component={Profile}/>

                    <Route path={`${match.url}/branches`} exact component={Branches}/>
                    <Route path={`${match.url}/branches/new`} exact component={BranchContainer}/>
                    <Route path={`${match.url}/branches/:branch/edit`} component={BranchContainer}/>

                    <Route path={`${match.url}/contractors`} exact component={Contractors}/>
                    <Route path={`${match.url}/contractors/new`} exact component={ContractorContainer}/>
                    <Route path={`${match.url}/contractors/:contractor/edit`} component={ContractorContainer}/>
                    <Route path={`${match.url}/contractors/:contractor/properties`} component={ContractorProperties}/>

                    <Route path={`${match.url}/properties`} exact component={Properties}/>
                    <Route path={`${match.url}/properties/new`} exact component={Property}/>
                    <Route path={`${match.url}/properties/:property/edit`} component={Property}/>
                    <Route path={`${match.url}/properties/retired`} exact component={RetiredProperties}/>
                    <Route path={`${match.url}/properties/import`} exact component={() => 'Import property list'}/>

                    {role !== 'landlord_admin' ? (
                        <Route path={`${match.url}/admins`} exact component={Admins}/>
                    ) : null}

                    {role !== 'landlord_admin' ? (
                        <Route path={`${match.url}/admins/new`} exact component={AdminContainer}/>
                    ) : null}

                    {role !== 'landlord_admin' ? (
                        <Route path={`${match.url}/admins/:admin/edit`} component={AdminContainer}/>
                    ) : null}

                    <Route path={`${match.url}/dlo/engineers`} component={Engineers}/>
                    <Route path={`${match.url}/dlo/non-engineers`} component={NonEngineers}/>
                    <Route exact path={`${match.url}/settings/dlo`} component={Settings}/>
                    <Route exact path={`${match.url}/settings/contractors`} component={ContractorSettings}/>
                </Switch>
            </div>
        );
    }
    renderLoading() {
        const icon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
        return <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bottom: 0,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0
        }}>
            <Spin size="large" tip="LOADING" indicator={icon}/>
        </div>;
    }
    render() {
        const {me: {isFetching}} = this.props;
        const renderSidebar = props => <Sidebar {...props}/>;

        return (
            <Layout renderSidebar={renderSidebar}>
                {isFetching ? this.renderLoading() : this.renderRoutes()}
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        me: state.me,
        auth: state.auth
    };
}

export default connect(mapStateToProps)(Root);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Root.js